<template>
  <div class="ml-1 mr-1">
    <div class="mb-2" v-for="(item, index) in items" :key="index">
      <span v-if="bussinessType =='primary'" class="ml-2 mr-1 bussiness-text font-bold">Bussiness</span>
      <span v-if="bussinessType =='primary'">: {{item.partnerType[0].text}}</span>
    </div>
    <table class="table table-bordered table-background">
      <thead class="thead-background">
        <tr>
          <th class="heading-fonts" v-for="field in fields" :key="field">{{field}}</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <!-- {{item}} -->
      <tbody v-if="bussinessType =='primary'">
        <tr v-for="(item, index) in items" :key="index">
          <td>
            <!-- <span v-if="editIndex !== index">
              <span v-for="(categories,index) in item.categories" :key="index">
                <span v-if="index!=item.categories.length-1">{{categories.name}},</span>
                <span v-else>{{ categories.name }}</span>
              </span>
            </span>-->
            <span v-if="editIndex === index">
              <!-- {{item.categories}} -->
              <multiSelect
                id="multiSelectPrimaryCategory"
                :disabled="!item.primaryBusiness"
                class="field-headings pt-1"
                v-model="item.categories"
                :position="'top'"
                :options="options"
                :selectOptions="primaryCategory"
                :btnLabel="btnLabelPrimaryCategory"
                :search="true"
                @close="getSubCategory(item.categories, item)"
              />
            </span>
          </td>
          <td>
            <!-- <span v-if="editIndex !== index">
              <span v-for="(categories, index) in item.subCategories" :key="index">
                <span v-if="index!=item.subCategories.length-1">{{ categories.name }},</span>
                <span v-else>{{categories.name}}</span>
              </span>
            </span>-->
            <span v-if="editIndex === index">
              <!-- {{item.subCategories}} -->
              <multiSelect
                id="multiSelectPrimarySubCategory"
                class="field-headings pt-1"
                v-model="item.subCategories"
                :position="'top'"
                :options="options"
                :search="true"
                :selectOptions="primarySubCategory"
                :btnLabel="btnLabelPrimaryCategory"
                :disabled="item.categories && item.categories.length == 0"
              />
            </span>
          </td>
          <td>
            <!-- <span v-if="editIndex !== index">{{item.primaryCategoryApproval[0].text}}</span> -->
            <span v-if="editIndex === index">
              <b-form-select
                @change="getPrimaryBussinessApproval(item.primaryBusiness, item)"
                v-model="item.primaryCategoryApproval[0].value"
                :options="parimaryCategory(item.categories)"
              ></b-form-select>
            </span>
          </td>
          <td>
            <span v-if="editIndex !== index">
              <a @click="edit(item, index)">
                <img src="@/assets/edit.svg" />
              </a>
            </span>
            <span v-if="editIndex == index">
              <a @click="save(item)">
                <img
                  src="@/assets/done.svg"
                  :class="checkPrimaryCategory.length>0 &&item.subCategories.length >0  ? '':'savedisabled'"
                />
              </a>
            </span>
          </td>
          <td>
            <!-- <span v-if="editIndex !== index">
              <a @click="remove(item, index)">
                <img src="@/assets/trash-round.svg" />
              </a>
            </span>-->
            <span v-if="editIndex == index">
              <a @click="cancel(item, index)">
                <img src="@/assets/cancel.svg" />
              </a>
            </span>
          </td>
        </tr>
      </tbody>
      <tbody v-if="bussinessType =='secondary'">
        <tr v-for="(item, index) in items" :key="index">
          <td>
            <span v-if="editIndex !== index">
              <span v-if="bussinessType =='secondary'">
                <span v-for="business in primaryBusiness" :key="business">
                  <span v-if="business.value == item.primaryBusiness">{{business.text}}</span>
                </span>
              </span>
              <!-- <span v-if="bussinessType =='primary'">
                <span>{{item.partnerType[0].text}}</span>
              </span>-->
            </span>
            <span v-if="editIndex === index">
              <span v-if="bussinessType =='secondary'">
                <b-form-select
                  @change="getCategory(item.primaryBusiness, item)"
                  v-model="item.primaryBusiness"
                  :options="primaryBusiness"
                  :disabled="edited"
                ></b-form-select>
              </span>
              <!-- <span v-if="bussinessType =='primary'">
                <b-form-select
                  @change="getCategory(item.primaryBusiness, item)"
                  v-model="item.primaryBusiness"
                  :options="item.partnerType"
                  :disabled="edited"
                ></b-form-select>
              </span>-->
            </span>
          </td>
          <td>
            <span v-if="editIndex !== index">
              <span v-for="(categories,index) in item.categories" :key="index">
                <span v-if="index!=item.categories.length-1">{{categories.name}},</span>
                <span v-else>{{ categories.name }}</span>
              </span>
            </span>
            <span v-if="editIndex === index">
              <!-- {{item.categories}} -->
              <multiSelect
                id="multiSelectPrimaryCategory"
                :disabled="!item.primaryBusiness"
                class="field-headings pt-1"
                v-model="item.categories"
                :position="'top'"
                :options="options"
                :search="true"
                :selectOptions="primaryCategory"
                :btnLabel="btnLabelPrimaryCategory"
                @close="getSubCategory(item.categories, item)"
              />
            </span>
          </td>
          <td>
            <span v-if="editIndex !== index">
              <span v-for="(categories, index) in item.subCategories" :key="index">
                <span v-if="index!=item.subCategories.length-1">{{ categories.name }},</span>
                <span v-else>{{categories.name}}</span>
              </span>
            </span>
            <span v-if="editIndex === index">
              <!-- {{item.subCategories}} -->
              <multiSelect
                id="multiSelectPrimarySubCategory"
                class="field-headings pt-1"
                v-model="item.subCategories"
                :position="'top'"
                :search="true"
                :options="options"
                :selectOptions="primarySubCategory"
                :btnLabel="btnLabelPrimaryCategory"
                :disabled="item.categories && item.categories.length == 0"
              />
            </span>
          </td>
          <td>
            <span v-if="editIndex !== index">
              <a @click="edit(item, index)">
                <img src="@/assets/edit.svg" />
              </a>
            </span>
            <span v-if="editIndex == index">
              <a @click="save(item)">
                <img
                  src="@/assets/done.svg"
                  :class="checkPrimaryCategory.length>0 &&item.subCategories.length >0  ? '':'savedisabled'"
                />
              </a>
            </span>
          </td>
          <td>
            <span v-if="editIndex !== index">
              <a @click="remove(item, index)">
                <img src="@/assets/trash-round.svg" />
              </a>
            </span>
            <span v-if="editIndex == index">
              <a @click="cancel(item, index)">
                <img src="@/assets/cancel.svg" />
              </a>
            </span>
          </td>
        </tr>
      </tbody>
      <tbody v-if="bussinessType =='branch'">
        <tr v-for="(item, index) in items" :key="index">
          <td>
            <!-- <span v-if="editIndex !== index">
              <span v-for="(categories,index) in item.categories" :key="index">
                <span v-if="index!=item.categories.length-1">{{categories.name}},</span>
                <span v-else>{{ categories.name }}</span>
              </span>
            </span>-->
            <span v-if="editIndex === index">
              <!-- {{item.categories}} -->
              <multiSelect
                id="multiSelectPrimaryCategory"
                :disabled="!item.primaryBusiness"
                class="field-headings pt-1"
                v-model="item.categories"
                :search="true"
                :position="'top'"
                :options="options"
                :selectOptions="branchCategory"
                :btnLabel="btnLabelPrimaryCategory"
                @close="getSubCategory(item.categories, item)"
              />
            </span>
          </td>
          <td>
            <!-- <span v-if="editIndex !== index">
              <span v-for="(categories, index) in item.subCategories" :key="index">
                <span v-if="index!=item.subCategories.length-1">{{ categories.name }},</span>
                <span v-else>{{categories.name}}</span>
              </span>
            </span>-->
            <span v-if="editIndex === index">
              <!-- {{item.subCategories}} -->
              <multiSelect
                id="multiSelectPrimarySubCategory"
                class="field-headings pt-1"
                v-model="item.subCategories"
                :position="'top'"
                :search="true"
                :options="options"
                :selectOptions="branchsubCategories"
                :btnLabel="btnLabelPrimaryCategory"
                :disabled="item.categories && item.categories.length == 0"
              />
            </span>
          </td>

          <td>
            <span v-if="editIndex !== index">
              <a @click="edit(item, index)">
                <img src="@/assets/edit.svg" />
              </a>
            </span>
            <span v-if="editIndex == index">
              <a @click="save(item)">
                <img
                  src="@/assets/done.svg"
                  :class="checkPrimaryCategory.length>0 &&item.subCategories.length >0  ? '':'savedisabled'"
                />
              </a>
            </span>
          </td>
          <td>
            <!-- <span v-if="editIndex !== index">
              <a @click="remove(item, index)">
                <img src="@/assets/trash-round.svg" />
              </a>
            </span>-->
            <span v-if="editIndex == index">
              <a @click="cancel(item, index)">
                <img src="@/assets/cancel.svg" />
              </a>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="text-center" v-if="bussinessType !='branch'">
      <button
        v-if="bussinessType !='primary'"
        class="button_bussiness mt-3"
        @click="add()"
        :class="(errors.items.length>0 || edited || isButtonDisabled) ? 'disabled':''"
      >+ ADD NEW BUSINESS</button>
      <br v-else />
    </div>
  </div>
</template>

<script>
import multiSelect from "vue-multi-select";
import { DashboardService } from "../services/DashboardService";
const service = new DashboardService();

export default {
  name: "About",
  props: ["items", "partnerId", "fields", "bussinessType"],
  created() {
    this.getPartnerInfo();
    console.log(this.items);
    if (this.bussinessType == "primary") {
      this.edit(this.items[0], 0);
    } else if (this.bussinessType == "branch") {
      console.log(this.items);
      this.edit(this.items[0], 0);
    }
    this.checkItemEmpty();
  },
  components: {
    multiSelect
  },
  data() {
    return {
      allowSave: true,
      isButtonDisabled: false,
      companyCode: "",
      currentCompanyCode: "",
      editIndex: null,
      originalData: null,
      error: false,
      categoryOptions: [
        {
          text: "Please select an option",
          value: 2
        }
      ],
      duplicate: false,
      primaryBusiness: [],
      primaryCategory: [],
      primarySubCategory: [],
      checkPrimaryCategory: [],
      edited: false,
      options: {
        multi: true,
        groups: false,
        labelList: "elements",
        groupName: "title",
        cssSelected: option =>
          option.selected
            ? {
                "background-color": "#ffffff"
              }
            : ""
      },
      btnLabelPrimaryCategory: values =>
        `Selected Categories (${values.length})`,
      btnLabelPrimarySubCategory: values =>
        `Selected Sub Categories (${values.length})`
    };
  },
  methods: {
    checkItemEmpty() {
      if (this.items.length == 0) {
        this.editIndex = 0;
        this.items.push({});
        this.isButtonDisabled = true;
      } else {
        if (this.items[0].categories.length == 0) {
          this.items.splice(0, 1);
          this.editIndex = 0;
          this.items.push({});
          this.isButtonDisabled = true;
        }
      }
    },
    parimaryCategory(types) {
      var bussinessTypes = [];
      types.forEach(item => {
        bussinessTypes.push({
          text: item.name,
          value: item.value
        });
      });
      return bussinessTypes;
    },
    getPartnerInfo() {
      service.getPartnerDetails().then(resp => {
        if (resp.response) {
          // this.partnerId = resp.response.companyCode;
          this.companyCode = resp.response.companyCode;
          this.currentCompanyCode = resp.response.currentCompanyCode;
        this.$root.isInternational =
              resp.response.countryDetail.countryCode == 100 ? false : true;
          this.getBusiness();
        }
      });
    },
    getBusiness() {
      service.getBussiness(this.companyCode).then(resp => {
        let res = resp.response;
        for (let i = 0; i < res.length; i++) {
          this.primaryBusiness.push({
            text: res[i].longDesc,
            value: res[i].categoryCode
          });
        }
      });
    },
    getCategory(primaryBusiness, item) {
      service.getPrimaryCategoryList(primaryBusiness).then(resp => {
        let res = resp.response;
        this.primaryCategory = [];
        for (let i = 0; i < res.length; i++) {
          this.primaryCategory.push({
            name: res[i].longDesc,
            value: res[i].categoryCode
          });
        }
        // this.getSubCategory(this.primaryCategory);
      });
    },
    getSubCategory(primaryCategory, item) {
      var categoryArray = [];
      for (let i = 0; i < primaryCategory.length; i++) {
        this.checkPrimaryCategory.push(primaryCategory[i].value);
        categoryArray.push(primaryCategory[i].value);
      }
      service.getSubCategoryList(categoryArray).then(resp => {
        let res = resp.response;
        console.log(this.primarySubCategory);
        this.primarySubCategory = [];
        for (let i = 0; i < res.length; i++) {
          this.primarySubCategory.push({
            name: res[i].longDesc,
            value: res[i].categoryCode
          });
        }
        console.log(this.primarySubCategory);
      });
    },
    add() {
      this.error = false;
      this.edited = false;
      this.isButtonDisabled = true;
      console.log(this.items);

      let len = this.items.length - 1;
      if (this.items.length == 0) {
        this.originalData = null;
        this.items.push({});
        this.editIndex = this.items.length - 1;
      } else if (
        this.items[len].primaryBusiness &&
        this.items[len].categories &&
        this.items[len].subCategories
      ) {
        this.originalData = null;
        this.items.push({});
        this.editIndex = this.items.length - 1;
      } else {
        this.error = true;
      }
    },

    edit(item, index) {
      console.log(item);
      this.edited = true;
      // var itemCategories = [];
      if (this.bussinessType != "branch") {
        this.getCategory(item.primaryBusiness, item);
        this.getSubCategory(item.categories);
        this.$emit("addSecondaryBussinessEvent", this.items);
        console.log(this.items);
        this.originalData = Object.assign({}, item);
      } else {
        console.log(item);
        // this.getBranchCategory(item.primaryBusiness, item);
        // this.getBranchSubCategory(item.categories);
        this.primaryCategory.push(item.categories);
        this.primarySubCategory.push(item.subCategories);
        this.$emit("addSecondaryBussinessEvent", this.items);
        console.log(this.items);
        //       primaryCategory: [],
        // primarySubCategory: [],
      }

      // for (let i = 0; i < this.items.length; i++) {
      //   for (let j = 0; j < this.items[i].categories.length; j++) {
      //     itemCategories.push(this.items[i].categories[j]);
      //   }
      // }
      // var _this = this;
      // setTimeout(function() {
      //   _this.getSubCategory(itemCategories, item);
      //   _this.$emit("addSecondaryBussinessEvent", _this.items);
      // }, 3000);

      this.editIndex = index;
      console.log(item);
    },

    cancel(item, index) {
      this.error = false;
      this.editIndex = null;
      this.edited = false;
      this.isButtonDisabled = false;
      Object.assign(item, this.originalData);
      this.originalData = null;
      if (!item.primaryBusiness) {
        this.items.splice(index, 1);
      }
      this.$emit("addSecondaryBussinessEvent", this.items);
    },

    remove(item, index) {
      console.log(item);
      var slectedCategories = [];
      var slectedSubCategories = [];
      item.categories.forEach(element => {
        slectedCategories.push(element.value);
      });
      item.subCategories.forEach(element => {
        slectedSubCategories.push(element.value);
      });
      let data = {};
      this.duplicate = false;
      // this.items.splice(index, 1);
      this.isButtonDisabled = false;
      data.companyCode = item.company;
      data.partnerId = this.partnerId;
      data.categoryCode = item.primaryBusiness;
      data.categories = slectedCategories;
      data.subCategories = slectedSubCategories;
      data.companyCode = this.currentCompanyCode;
      console.log(data);
      service.deleteSecondaryBusiness(data).then(res => {
        if (res.failureMessage == "") {
          this.$emit("addSecondaryBussinessEvent", this.items);
          this.$emit("closeModal", this.items);
        } else {
          this.$emit("showFailureModal", res.failureMessage);
        }
      });
    },

    save(item) {
      console.log(item);
      let r = this.items.length - 1;
      for (let i = 0; i <= this.items.length - 2; i++) {
        if (this.items[i].primaryBusiness == this.items[r].primaryBusiness) {
          this.allowSave = false;
          this.isButtonDisabled = false;
          this.$emit("showFailureModal", null);
          this.items.splice(r, 1);
          console.log(this.items);
        }
      }
      if (this.allowSave == true) {
        let len = this.items.length - 1;
        if (
          this.items[len].primaryBusiness.length &&
          this.items[len].categories.length > 0 &&
          this.items[len].subCategories.length > 0
        ) {
          this.error = false;
          this.originalData = null;
          this.editIndex = null;
        } else {
          this.error = true;
        }
        var categoriesToSend = [];
        var subCategoriesToSend = [];
        for (let i = 0; i < item.categories.length; i++) {
          categoriesToSend.push(item.categories[i].value);
        }
        for (let i = 0; i < item.subCategories.length; i++) {
          subCategoriesToSend.push(item.subCategories[i].value);
        }
        if (this.edited == true) {
          console.log(categoriesToSend);
          console.log(subCategoriesToSend);
          if (categoriesToSend.length > 0 && subCategoriesToSend.length > 0) {
            let editData = {};
            if (this.bussinessType == "primary") {
              editData.primaryCode = item.primaryCategoryApproval[0].value;
            }
            editData.partnerId = this.partnerId;
            editData.businessType = this.bussinessType == "primary" ? "P" : "S";
            editData.partnerBusinessCode = item.primaryBusiness;
            editData.partnerBusinessTypeCodes = [];
            editData.categories = categoriesToSend;
            editData.subCategories = subCategoriesToSend;
            editData.companyCode = this.currentCompanyCode;
            console.log(editData);
            if (this.bussinessType == "primary") {
              service.editPrimaryBusiness(editData).then(resp => {
                let res = resp.response;
                this.edited = false;
                this.editIndex = null;
                this.isButtonDisabled = false;
                this.$emit("addSecondaryBussinessEvent", this.items);
                this.$emit("closeModal", this.items);
              });
            } else {
              service.editSecondaryBusiness(editData).then(resp => {
                let res = resp.response;
                this.edited = false;
                this.editIndex = null;
                this.isButtonDisabled = false;
                this.$emit("addSecondaryBussinessEvent", this.items);
              });
            }
          }
        } else {
          let data = {};
          data.secondaryBusiness = item.primaryBusiness;
          data.secondaryCategory = categoriesToSend;
          data.secondarySubCategory = subCategoriesToSend;
          data.companyCode = this.currentCompanyCode;
          if (categoriesToSend.length > 0 && subCategoriesToSend.length > 0) {
            service.saveSecondaryBusiness(data).then(resp => {
              let res = resp.response;
              this.editIndex = null;
              this.isButtonDisabled = false;
              this.$emit("addSecondaryBussinessEvent", this.items);
            });
          }
        }
      }
    }
  }
};
</script>
<style scoped>
.button_bussiness {
  border: none;
  padding: 15px 32px;
  text-align: center;
  margin: 4px 2px;
  cursor: pointer;
  border: solid 1px #002d72;
  background-color: white;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.55;
  letter-spacing: 0.88px;
  color: #002d72;
}
.disabled {
  pointer-events: none;
  cursor: not-allowed;
  background-color: #cccccc;
  color: #666666;
}
.savedisabled {
  cursor: not-allowed;
}
.errorWidth {
  font-size: 12px !important;
  width: 100% !important;
  padding: 2px !important;
}
img {
  cursor: pointer;
}
.heading-fonts {
  font-weight: normal;
  font-size: 14px;
}
.field-padding {
  padding-left: 10px;
}
.error {
  background: #f8d7da;
  border-color: #f5c6cb;
  padding: 0.75rem 1.25rem;
  color: #721c24;
  width: 100%;
  text-align: center;
}
.header-bg {
  background-color: #e9ecef !important;
  border-color: #dee2e6 !important;
}
.thead-background {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  background-color: #6192b1 !important;
  color: #ffffff !important;
}
.table-background {
  border-radius: 4px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
}
.bussiness-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  font-weight: 600;
}
</style>

